import React from "react";
import styled from "styled-components";

// 스타일드 컴포넌트
const Container = styled.div`
  background-color: rgb(60, 13, 153);
  padding: 60px 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin: 80px auto 80px;
  flex-direction: row;
  justify-content: space-between;
  width: 1200px;

  @media (max-width: 1200px) {
    width: calc(100% - 40px);
    flex-direction: column;
    padding: 40px 20px;
    margin: 60px auto 60px;
  }
`;

const Text = styled.p`
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  width: 50%;
  line-height: 1.5;

  @media (max-width: 1200px) {
    width: 100%;
    font-size: 18px;
    margin-bottom: 30px;
  }
`;

const Button = styled.button`
  background-color: #ffffff;
  color: rgba(88, 80, 236, 1);
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 500;
  padding: 20px 60px;
  border-radius: 6px;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ececec;
  }

  @media (max-width: 1200px) {
    width: 100%;
    padding: 15px 40px;
    font-size: 16px;
  }
`;

// 컴포넌트
const PromoBanner = ({ onClick }) => {
  return (
    <Container id="contact">
      <Text>
        まもなく公開！
        <br />
        今すぐ事前予約して、
        <br />
        韓国語学習の新しい時代を
        <br />
        一足先に体験してください
      </Text>
      <Button onClick={onClick}>事前予約＆特典</Button>
    </Container>
  );
};

export default PromoBanner;
